import type { Product } from '../types/commerce'

const CAN_LINEUP =
  'https://cdn.magicpatterns.com/uploads/4nRxNXZRgXs6U5T42kX5ab/Burk_1.png'
const CAN_IN_HAND =
  'https://cdn.magicpatterns.com/uploads/wDu3fKhK1RBeGFe1tY72ry/DSC03888.jpg'
const CAN_ON_ICE =
  'https://cdn.magicpatterns.com/uploads/knKE32EsZkYsqPa1ui7YrB/DSC03885.jpg'
const CAN_IN_ICE_TRAY =
  'https://cdn.magicpatterns.com/uploads/3Z7pvRTWTCQGQsaZFNiNKK/DSC03885.jpg'
const MARK_ON_BLACK =
  'https://cdn.magicpatterns.com/uploads/vxD4MWqXVEYWVzm95LHyfx/2.png'
const CASE_OF_CANS =
  'https://cdn.magicpatterns.com/uploads/qLhkXP8ogh7z6DoshQ1BbP/IMG_2476.png'

const CANS_IN_BOWL =
  'https://cdn.magicpatterns.com/uploads/p4Sk3dNMD8P9BQwDabDdK8/DSC04025.jpg'

const INGREDIENTS = [
  'Carbonated water',
  'Beetroot',
  'Grapefruit',
  'Pomegranate',
  'Lemon',
  'Elderflower',
  'Apple juice concentrate',
  'Apple cider vinegar',
  'Prebiotic fibre',
]

const NUTRITION = [
  { label: 'Energy', value: '85 kJ / 20 kcal' },
  { label: 'Fat', value: '0 g' },
  { label: 'Carbohydrate', value: '4.5 g' },
  { label: 'of which sugars', value: '4.3 g' },
  { label: 'Protein', value: '0 g' },
  { label: 'Salt', value: '0.05 g' },
]

const DETAILS = [
  '250 ml cans',
  'No added sugar',
  'Caffeine free',
  'Alcohol free',
  'Nothing artificial',
  'Best served cold, straight from the can or over ice',
]

/**
 * MOCK DATA — replace with live Shopify products.
 *
 * Adding a future flavour (Yellow BEAT, White BEAT) is just another entry in
 * this array; the shop, product page and cart are all driven by it.
 */
export const products: Product[] = [
  {
    id: 'mock-beat-red-12',
    variantId: 'mock-variant-beat-red-12',
    handle: 'beat-red-12',
    name: 'BEAT RED',
    packLabel: '12 Pack',
    cans: 12,
    tagline: 'Beetroot, grapefruit and elderflower. Earthy, bright, bittersweet.',
    description:
      'The original. Deep red beetroot met with grapefruit and elderflower — earthy underneath, bright on top, dry on the finish. A drink for the moments worth remembering.',
    price: { amount: 349, currencyCode: 'SEK' },
    availableForSale: false,
    badge: 'Sold out',
    images: [CAN_IN_ICE_TRAY, CAN_LINEUP, CAN_IN_HAND, CAN_ON_ICE],
    imageZoom: 2.1,
    imageFocus: '54% 52%',
    ingredients: INGREDIENTS,
    nutrition: NUTRITION,
    details: DETAILS,
  },
  {
    id: 'mock-beat-red-24',
    variantId: 'mock-variant-beat-red-24',
    handle: 'beat-red-24',
    name: 'BEAT RED',
    packLabel: '24 Pack',
    cans: 24,
    tagline: 'The case you buy when people are coming over.',
    description:
      'The original, by the case. Deep red beetroot met with grapefruit and elderflower — earthy underneath, bright on top, dry on the finish. Enough for a dinner, a weekend, or a fridge that never runs empty.',
    price: { amount: 599, currencyCode: 'SEK' },
    compareAtPrice: { amount: 698, currencyCode: 'SEK' },
    availableForSale: false,
    badge: 'Sold out',
    images: [CAN_IN_ICE_TRAY, CASE_OF_CANS, CANS_IN_BOWL],
    imageZoom: 2.1,
    imageFocus: '54% 52%',
    ingredients: INGREDIENTS,
    nutrition: NUTRITION,
    details: DETAILS,
  },
  {
    id: 'mock-beat-mixed-24',
    variantId: 'mock-variant-beat-mixed-24',
    handle: 'beat-mixed-24',
    name: 'BEAT MIXED CASE',
    packLabel: '24 Pack',
    cans: 24,
    tagline: 'Red, Yellow and White. The whole range, one case.',
    description:
      'All three BEAT flavours in one case — Red, Yellow and White. Yellow and White land soon; join the list and you will be first to know when the mixed case opens.',
    price: { amount: 649, currencyCode: 'SEK' },
    availableForSale: false,
    badge: 'Coming soon',
    images: [MARK_ON_BLACK, CAN_LINEUP, CANS_IN_BOWL],
    imageZoom: 1.6,
    ingredients: INGREDIENTS,
    nutrition: NUTRITION,
    details: DETAILS,
  },
]
